<!--
 * @Author: DQL
 * @Date: 2020-08-18 14:53:58
 * @LastEditors: DQL
 * @LastEditTime: 2021-05-06 10:08:26
 * @Description: 管理员级别维护
-->
<template>
  <el-row
    v-loading="loading"
    type="flex"
    class="l-page l-page--nav page-user"
  >
    <!-- 左侧导航模块 Start -->
    <el-col
      class="l-page__aside"
      :xl="5"
      :lg="6"
      :span="8"
    >
      <div
        class="l-page--inner l-page--aside"
      >
        <!-- 左侧头部 Start -->
        <div
          class="l-page__header"
        >
          <!-- 左侧标题 -->
          <h2
            class="c-page__header-title"
          >
            管理员级别
          </h2>
        </div>
        <!-- 左侧头部 End -->

        <!-- 左侧导航主内容 Start -->
        <div
          class="l-page__body"
        >
          <hm-page-card
            class="c-card--aside"
          >
            <!-- 树导航 Start -->
            <div
              class="c-asideTree"
            >
              <div
                class="c-asideTree__body"
              >
                <!-- tree的ref的命名根据业务名称修改 -->
                <el-tree
                  ref="adminLevel"
                  class="o-tree-overflow--unset"
                  node-key="adminLevel"
                  highlight-current
                  :data="adminLevelList"
                  :props="defaultProps"
                  @node-click="handleNodeClick"
                />
              </div>
            </div>
            <!-- 树导航 End -->
          </hm-page-card>
        </div>
        <!-- 左侧导航主内容 End -->
      </div>
    </el-col>
    <!-- 左侧导航模块 End -->

    <!-- 右侧主面板模块 Start -->
    <el-col
      class="l-page__panel"
      :xl="19"
      :lg="18"
      :span="16"
    >
      <!-- 右侧内容：基础详情类布局 Start -->
      <div
        class="l-page--inner l-page--detail"
      >
        <!-- 页面头部 Start -->
        <div
          class="l-page__header c-page__header"
        >
          <!-- 页面标题 -->
          <h2
            class="c-page__header-title"
          >
            管理员列表
          </h2>

          <!-- 标题栏按钮区域 Start -->
          <div
            class="c-page__header-btns"
          >
            <el-button
              v-permission-admin-element
              type="primary"
              icon="kestrel-icon ki-sync"
              @click="getAdminUsers()"
            >
              更新数据
            </el-button>
            <el-button
              v-permission-admin-element
              type="success"
              icon="kestrel-icon ki-plus"
              @click="handleAdd()"
            >
              新增
            </el-button>
            <el-button
              v-permission-admin-element
              type="danger"
              icon="kestrel-icon ki-trash-o"
              plain
              :disabled="multipleSelectedRow.length<=0"
              @click="handleDel(multipleSelectedRow)"
            >
              删除
            </el-button>
          </div>
          <!-- 标题栏按钮区域 End -->
        </div>
        <!-- 页面头部 End -->

        <!-- 页面主内容：详情 Start -->
        <div
          class="l-page__body l-page--detail__body"
        >
          <hm-page-card
            class="c-card--detail"
          >
            <!-- table的ref的命名根据业务名称修改 -->
            <el-table
              ref="listTable"
              class="c-page__table o-header-text-center"
              height="100%"
              stripe
              border
              highlight-current-row
              tooltip-effect="dark"
              :data="pageList"
              :class="{ 'o-table-empty-center': pageList.length <= 0 }"
              @selection-change="handleSelectionChange"
            >
              <el-table-column
                type="selection"
                width="30"
                align="center"
              />
              <el-table-column
                prop="capacityCode"
                label="身份编码"
                min-width="160"
                show-overflow-tooltip
              />
              <el-table-column
                prop="capacityName"
                label="身份名称"
                min-width="160"
                show-overflow-tooltip
              />
              <el-table-column
                prop="userCode"
                label="用户编码"
                min-width="140"
                show-overflow-tooltip
              />
              <el-table-column
                prop="userName"
                label="用户名称"
                min-width="140"
                show-overflow-tooltip
              />
              <el-table-column
                prop="deptName"
                label="所属机构部门"
                min-width="240"
                show-overflow-tooltip
              />
            </el-table>
          </hm-page-card>
        </div>
        <!-- 页面主内容：详情 End -->
      </div>
      <!-- 右侧内容：基础详情类布局 End -->
    </el-col>
    <!-- 右侧主面板模块 End -->

    <!-- 新增管理员组件 -->
    <add-dialog
      v-if="showDialogName==='add'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="getAdminUsers"
    />
  </el-row>
</template>

<script>
import _ from 'lodash';
import { adminLevelManageService } from './adminLevelManage.service.js';
export default {
  name: 'AdminLevelManage',
  components: {
    addDialog: () => import('./addDialog')
  },
  data () {
    return {
      loading: false, // 页面loading状态

      /* 树组件配置 Start */
      adminLevelList: [], // 管理员级别 && 用户列表

      // 树组件默认参数配置
      defaultProps: {
        label: 'name'
      },
      /* 树组件配置 End */

      currentAdmin: { // 当前选中的管理员级别
        adminLevel: null,
        name: null
      },

      pageList: [], // 管理员列表数据
      multipleSelectedRow: [], // 用户列表选中行

      /* 弹窗 Start */
      showDialogName: '',
      dialogParams: {}
      /* 弹窗 End */

    };
  },
  methods: {
    /**
     * @description: 获取管理员用户（树结构，包含管理员级别以及级别下的用户列表）
     * @param {*}
     * @return {*}
     */
    getAdminUsers () {
      const _this = this;
      _this.loading = true;
      adminLevelManageService.list()
        .then(rsp => {
          _this.adminLevelList = rsp.data;
          if (_this.currentAdmin.adminLevel) {
            // 刷新数据触发的加载
            // 循环获取的数据，已选择的管理员级别是否还存在，存在则赋值已选的级别以及级别下用户数据，不存在则初始化数据
            for (let index = 0; index < _this.adminLevelList.length; index++) {
              const _levelItem = _this.adminLevelList[index];
              if (_levelItem.adminLevel === _this.currentAdmin.adminLevel) {
                // 存在已选择的管理员级别
                _this.pageList = rsp.data[index].adminUsers;
                _this.$nextTick(() => {
                  _this.$refs.adminLevel.setCurrentKey(_this.currentAdmin.adminLevel);
                });
                return;
              }
              if (index === rsp.data.length - 1 && _levelItem.adminLevel !== _this.currentAdmin.adminLevel) {
                // 循环到最后一个，还是未查找到已选择的管理员级别，重新初始化数据
                if (rsp.data && rsp.data.length > 0) {
                  // 初始数据
                  _this.currentAdmin.adminLevel = rsp.data[0].adminLevel;
                  _this.currentAdmin.name = rsp.data[0].name;
                  _this.pageList = rsp.data[0].adminUsers;
                  _this.$nextTick(() => {
                    _this.$refs.adminLevel.setCurrentKey(_this.currentAdmin.adminLevel);
                  });
                }
              }
            }
          } else if (rsp.data && rsp.data.length > 0) {
            // 初始数据
            _this.currentAdmin.adminLevel = rsp.data[0].adminLevel;
            _this.currentAdmin.name = rsp.data[0].name;
            _this.pageList = rsp.data[0].adminUsers;
            _this.$nextTick(() => {
              _this.$refs.adminLevel.setCurrentKey(_this.currentAdmin.adminLevel);
            });
          }
        })
        .catch(err => {
          console.error('获取管理员用户错误！', err);
        })
        .finally(() => {
          _this.loading = false;
        });
    },
    /**
     * @description: 树节点点击事件
     * @param {Object} data
     * @param {Object} node
     * @return {*}
     */
    handleNodeClick (data, node) {
      this.currentAdmin.adminLevel = data.adminLevel;
      this.currentAdmin.name = data.name;
      this.pageList = data.adminUsers;
      this.multipleSelectedRow = [];
    },
    /**
     * @description: 表格选中行事件（多选）
     * @param {Object} val
     * @return {*}
     */
    handleSelectionChange (val) {
      this.multipleSelectedRow = val;
    },
    /**
     * @description: 新增用户
     * @param {*}
     * @return {*}
     */
    handleAdd () {
      if (!this.currentAdmin.adminLevel) {
        this.$alert('请选择管理员级别！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        });
        return;
      }
      this.handleDialog('add', { adminLevel: this.currentAdmin.adminLevel, adminLevelName: this.currentAdmin.name });
    },
    /**
     * @description: 批量删除用户
     * @param {Array} _row 当前选中行的用户数据
     * @return {*}
     */
    handleDel (_row) {
      const _this = this;
      const users = [];
      const delUserList = _this.multipleSelectedRow.map(_row => {
        users.push(`${_row.userName}(${_row.capacityName})`);
        return {
          adminLevel: _this.currentAdmin.adminLevel,
          capacityCode: _row.capacityCode
        };
      });
      const usersStr = _.join(users, '、');
      _this.$confirm(`是否确认批量删除这些用户【${usersStr}】？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        adminLevelManageService.delete(delUserList)
          .then(rsp => {
            _this.$alert('删除成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.getAdminUsers();
          })
          .catch(err => {
            console.error('删除出错！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 表格选中行事件
     * @param {Object} row
     * @param {Object} column
     * @param {any} event
     * @return {*}
     */
    handleRowClick (row, column, event) {
      this.multipleSelectedRow = row;
    },
    /**
     * @description: 通用显示模态框dialog组件
     * @param {String} _name 显示的模态框dialog名称
     * @param {Object} _params 模态框dialog传入参数
     * @return {*}
     */
    handleDialog (_name, _parmas) {
      this.showDialogName = _name;
      this.dialogParams = _parmas;
    }
  },
  created () {
    this.getAdminUsers();
  }
};
</script>

<style lang="scss">

</style>
